import React from "react";
import Header from "./desktopComp/Header/Header.js";
import Home from "./desktopComp/Home/Home.js";
import Footer from "./desktopComp/Footer/Footer.js";
import Placeholder from "./desktopComp/About/Placeholder";
import Menu from "./desktopComp/Menu/Menu.js";
import { Switch, Route, useLocation } from "react-router-dom";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import Contact from "./desktopComp/Contact/Contact.js";

export default function Desktop() {
  let location = useLocation();
  return (
    <div>
      <Header />
      <TransitionGroup>
        <CSSTransition key={location.key} classNames="fade" timeout={300}>
          <Switch location={location}>
            <Route exact path="/" children={<Home />}></Route>
            <Route exact path="/about" children={<Placeholder />}></Route>
            <Route exact path="/menu" children={<Menu />}></Route>
            <Route exact path="/contact" children={<Contact />}></Route>
          </Switch>
        </CSSTransition>
      </TransitionGroup>
      <Footer />
    </div>
  );
}
